import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

const EmptyGigsafeUsersComponent = () => {
  return (
    <div
      data-testid="gigsafe-users-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">No users found</Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        Invite someone to give this customer their first login.
      </Typography>
    </div>
  )
}

export const EmptyGigsafeUsers = memo(EmptyGigsafeUsersComponent)
